// extracted by mini-css-extract-plugin
export default {"app_policy":"RefundPolicy_app_policy__k9To-"};